import {AnalyticsQuerySpecRequest} from 'insights/analytics-queries/RESTAnalyticsQueryTypes';
import {
  DEFAULT_QUERY_DESCRIPTION,
  DEFAULT_SQL_QUERY,
  NO_RESULT_SQL_QUERY,
} from 'insights/warehouse/AnalyticsWarehouseConstants';

/**
 * Create AnalyticsQuery with default name, description and SQL query
 *
 * The default name is "Block {number}" (incremented if it conflicts with an existing name).
 * For example, if there are 4 blocks, the default name for the 5th block is:
 *   - "Block 5" if there are no existing blocks named "Block 5"
 *   - the first of "Block 6", "Block 7", etc. that doesn't conflict otherwise
 *
 * The SQL query is dependent on returnNoResults (when true, the query will have no results).
 *
 */
export default function createDefaultAnalyticsQuery(
  existingAnalyticsQueries: Array<{name: string}>,
  options: {returnNoResults: boolean} = {returnNoResults: false}
): AnalyticsQuerySpecRequest {
  const existingAnalyticsQueryNames = existingAnalyticsQueries.map((analyticsQuery) => analyticsQuery.name);
  let analyticsQueryNum = existingAnalyticsQueryNames.length + 1;
  let analyticsQueryName;
  do {
    analyticsQueryName = `Block ${analyticsQueryNum}`;
    ++analyticsQueryNum;
  } while (existingAnalyticsQueryNames.includes(analyticsQueryName));
  return {
    name: analyticsQueryName,
    description: DEFAULT_QUERY_DESCRIPTION,
    sqlQuery: options.returnNoResults ? NO_RESULT_SQL_QUERY : DEFAULT_SQL_QUERY,
  };
}
